<template>
  <div class="expertDetail">
    <h4 class="title">专家详情</h4>
    <el-card>
      <h4 class="titles">结直肠癌病例分享与解析第一期会议</h4>
    </el-card>
    <el-card>
      <div class="details">
        <h5 class="detail_detal">服务资料</h5>
        <ul class="list_box">
          <li>
            <h6>肿瘤研究资料</h6>
            <p>三阴型乳腺癌中AR、SOX10、EGFR和PD-L1的表达及临床意义</p>
          </li>
          <li>
            <h6>肿瘤研究资料</h6>
            <p>三阴型乳腺癌中AR、SOX10、EGFR和PD-L1的表达及临床意义</p>
          </li>
        </ul>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'expertDetail',
  data () {
    return {

    }
  },
  methods: {

  }
}
</script>

<style lang='less' scoped>
.expertDetail {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  .title {
    color: #212529;
    font-size: 28px;
    padding-bottom: 11px;
    border-bottom: 1px solid #e8e8e8;
  }
  .el-card {
    margin-top: 20px;
    .titles {
      font-size: 16px;
      font-weight: bold;
      color: #212529;
    }
    .details {
      width: 100%;
      min-height: 400px;
      border: 1px solid #f0f0f0;
      padding: 20px;
      border-radius: 8px;
    }
    .detail_detal {
      font-size: 16px;
      color: #212529;
    }
    .list_box {
      li {
        margin-top: 30px;
        h6 {
          font-size: 13px;
          color: #212529;
        }
        p {
          color: #6167aa;
          font-size: 13px;
          margin-top: 20px;
        }
      }
    }
  }
}
</style>
